"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = __importDefault(require("node-fetch"));
const constants_1 = require("../constants");
const types_1 = require("../meta/types");
const util_1 = require("../util/util");
const OldSchoolJSError_1 = __importDefault(require("./OldSchoolJSError"));
const Player_1 = __importDefault(require("./Player"));
const defaultGetOptions = {
    type: 'normal',
    virtualLevels: false
};
class Hiscores {
    fetch(username, options = { type: types_1.AccountType.Normal, virtualLevels: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            const mergedOptions = Object.assign(Object.assign({}, defaultGetOptions), options);
            if (!util_1.isValidUsername(username))
                throw new OldSchoolJSError_1.default(constants_1.Errors.INVALID_USERNAME);
            if (!constants_1.ACCOUNT_TYPES.includes(mergedOptions.type)) {
                throw new OldSchoolJSError_1.default(constants_1.Errors.INVALID_ACCOUNT_TYPE);
            }
            const data = yield node_fetch_1.default(constants_1.hiscoreURLs[mergedOptions.type] + username)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res.status === 404)
                    throw new OldSchoolJSError_1.default(constants_1.Errors.ACCOUNT_NOT_FOUND);
                if (!res.ok)
                    throw new OldSchoolJSError_1.default(constants_1.Errors.FAILED_REQUEST);
                const text = yield res.text();
                // If the text response is HTML, it means the hiscores are down.
                if (text.trim().startsWith('<'))
                    throw new OldSchoolJSError_1.default(constants_1.Errors.FAILED_REQUEST);
                return text;
            }))
                .then(util_1.resolvePlayerFromHiscores)
                .catch((err) => {
                throw err;
            });
            if (mergedOptions.virtualLevels) {
                let overall = 0;
                for (const skill in data.skills) {
                    if (skill === 'overall')
                        continue;
                    const lvl = util_1.convertXPtoLVL(data.skills[skill].xp, 126);
                    overall += lvl;
                    data.skills[skill].level = lvl;
                }
                data.skills.overall.level = overall;
            }
            return new Player_1.default({
                username,
                type: options.type,
                skills: data.skills,
                minigames: data.minigames,
                clues: data.clues,
                bossRecords: data.bossRecords
            });
        });
    }
}
exports.default = new Hiscores();
//# sourceMappingURL=Hiscores.js.map